import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginService } from './login.service';
import { ConfigKeys } from '../config/config.keys';
import {Filter} from '../models/filter.model';
import {ReqVisit} from '../models/reqvisit.model';
import {ResultDTO} from '../models/resultdto.model';

@Injectable()
export class DataServices {

  configKeys: ConfigKeys = new ConfigKeys();

  constructor(private httpClient: HttpClient, private loginService: LoginService) { }

  getAppParams() {

    if (!this.loginService.isAutenticated()) {
      this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    }

    const token = this.loginService.getIdToken();


    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });



    return this.httpClient.get(this.configKeys.API_URL_GET_APP_PARAMS, { headers: reqHeader });
  }

  getBanners(idCard: number) {

    if (!this.loginService.isAutenticated()) {
      this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    }

    const token = this.loginService.getIdToken();
    //console.log('TOKEN(data-services)' + token);

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });


    return this.httpClient.get(this.configKeys.API_URL_GET_BANNERS + 'idCard=' + idCard, { headers: reqHeader });
  }

  getBannersHomePage() {

    if (!this.loginService.isAutenticated()) {
      this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    }

    const token = this.loginService.getIdToken();
    //console.log('TOKEN(data-services)' + token);

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });


    return this.httpClient.get(this.configKeys.API_URL_GET_BANNERS_HOME_PAGE, { headers: reqHeader });
  }

  getPromos() {

    if (!this.loginService.isAutenticated()) {
      this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    }

    const token = this.loginService.getIdToken();
    //console.log('TOKEN(data-services)' + token);

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });


    return this.httpClient.get(this.configKeys.API_URL_GET_PROMOS, { headers: reqHeader });
  }


  getPromosByCard(idCard: number) {

    if (!this.loginService.isAutenticated()) {
      this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    }

    const token = this.loginService.getIdToken();
    //console.log('TOKEN(data-services)' + token);

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });


    return this.httpClient.get(this.configKeys.API_URL_GET_PROMOS_BY_CARD + 'idCard=' + idCard, { headers: reqHeader });
  }

  getPromosByPage(pageNumber: number) {

    if (!this.loginService.isAutenticated()) {
      this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    }

    const token = this.loginService.getIdToken();
    //console.log('TOKEN(data-services)' + token);

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });


    return this.httpClient.get(this.configKeys.API_URL_GET_PROMOS_BY_PAGE + "pageNumber=" + pageNumber + "&pageSize=" + this.configKeys.DEFAULT_PAGE_SIZE, { headers: reqHeader });
  }


  getPromosByCardPage(idCard: number, pageNumber: number) {

    if (!this.loginService.isAutenticated()) {
      this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    }

    const token = this.loginService.getIdToken();
   // console.log('TOKEN(data-services)' + token);

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });


    return this.httpClient.get(this.configKeys.API_URL_GET_PROMOS_BY_CARD_PAGE + "idCard=" + idCard + "&pageNumber=" + pageNumber + "&pageSize=" + this.configKeys.DEFAULT_PAGE_SIZE, { headers: reqHeader });
  }

  getPromosByCardPageFilter(filter: Filter, pageNumber: number, pageSize: number) {

    if (!this.loginService.isAutenticated()) {
      this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    }

    const token = this.loginService.getIdToken();
    // console.log('TOKEN(data-services)' + token);

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });


    return this.httpClient.get(this.configKeys.API_URL_GET_PROMOS_BY_CARD_PAGE_FILTER + "idCard="  + filter.idCard + "&keyWord=" + filter.keyWord + "&categoryId=" + filter.categoryId + "&stateId=" + filter.stateId
      + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize, { headers: reqHeader });
  }

  getCards() {

    if (!this.loginService.isAutenticated()) {
      this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    }

    const token = this.loginService.getIdToken();
    //console.log('TOKEN(data-services)' + token);

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });


    return this.httpClient.get(this.configKeys.API_URL_GET_CARDS, { headers: reqHeader });


  }

  getPromoById(idPromo: number) {

    //if (!this.loginService.isAutenticated()) {
      this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    //}

    const token = this.loginService.getIdToken();
    //console.log('TOKEN(data-services)' + token);

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });

     //console.log('PROMO_ID(2) ' + idPromo);

    return this.httpClient.get(this.configKeys.API_URL_GET_PROMO_BY_ID + "idPromo=" + idPromo, { headers: reqHeader });
  }


  getBranchesByCity(idPromo: number, city: string) {

    //if (!this.loginService.isAutenticated()) {
      this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    //}

    const token = this.loginService.getIdToken();
    //console.log('TOKEN(data-services)' + token);

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });

     //console.log('ID_PROMO:' + idPromo);
     //console.log('CITY:' + city);

    return this.httpClient.get(this.configKeys.API_URL_GET_BRANCHES_BY_CITY + "idPromo=" + idPromo + "&city=" + city, { headers: reqHeader });
  }

  getCategories() {

    if (!this.loginService.isAutenticated()) {
      this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    }

    const token = this.loginService.getIdToken();


    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });

    return this.httpClient.get(this.configKeys.API_URL_GET_CATEGORIES, { headers: reqHeader });
  }

  getStates() {

    if (!this.loginService.isAutenticated()) {
      this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    }

    const token = this.loginService.getIdToken();


    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });

    return this.httpClient.get(this.configKeys.API_URL_GET_STATES, { headers: reqHeader });
  }


  getNearByPromosByCard(idCard: number, userLat: number, userLon: number) {

    //if (!this.loginService.isAutenticated()) {
    this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    //}

    const token = this.loginService.getIdToken();
    //console.log('TOKEN(data-services)' + token);

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });

    //console.log('PROMO_ID(2) ' + idPromo);

    return this.httpClient.get(this.configKeys.API_URL_GET_NEARBY_PROMOS_BY_CARD + "idCard=" + idCard + "&userLat=" + userLat + "&userLon=" + userLon , { headers: reqHeader });
  }

  getRelatedPromos(idCard: number, idPromo: number, idCliente: string) {

    if (!this.loginService.isAutenticated()) {
      this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    }

    const token = this.loginService.getIdToken();
    // console.log('TOKEN(data-services)' + token);

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });

    return this.httpClient.get(this.configKeys.API_URL_GET_RELATED_PROMOS + "cardId="  + idCard + "&idPromo=" + idPromo + "&idCliente=" + idCliente, { headers: reqHeader });
  }

  recordVisit(reqVisit: ReqVisit) {

    if (!this.loginService.isAutenticated()) {
      this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    }

    const token = this.loginService.getIdToken();
    // console.log('TOKEN(data-services)' + token);


    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        Authorization: token
      })
    };


    const body = JSON.stringify(reqVisit);

    //console.log('recordVisit(request): ' + body);

    // @ts-ignore
    return this.httpClient.post<ResultDTO>(this.configKeys.API_URL_RECORD_VISIT, body, httpOptions);

  }

  getCampaign(idCamp: string) {

    if (!this.loginService.isAutenticated()) {
      this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    }

    const token = this.loginService.getIdToken();
    //console.log('TOKEN(data-services)' + token);

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });


    return this.httpClient.get(this.configKeys.API_URL_GET_CAMPAIGN + idCamp, { headers: reqHeader });
  }

  getPromosByCampPage(idCamp: number, pageNumber: number) {

    if (!this.loginService.isAutenticated()) {
      this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    }

    const token = this.loginService.getIdToken();
    // console.log('TOKEN(data-services)' + token);

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });


    return this.httpClient.get(this.configKeys.API_URL_GET_PROMOS_BY_CAMP + "idCamp=" + idCamp + "&pageNumber=" + pageNumber + "&pageSize=" + this.configKeys.DEFAULT_PAGE_SIZE, { headers: reqHeader });
  }


  getPromosByCampPageAll(idCamp: number, pageNumber: number) {

    if (!this.loginService.isAutenticated()) {
      this.loginService.login(this.configKeys.API_USER, this.configKeys.API_PWD);
    }

    const token = this.loginService.getIdToken();
    // console.log('TOKEN(data-services)' + token);

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });


    return this.httpClient.get(this.configKeys.API_URL_GET_PROMOS_BY_CAMP + "idCamp=" + idCamp + "&pageNumber=" + pageNumber + "&pageSize=" + this.configKeys.DEFAULT_PAGE_SIZE_ALL, { headers: reqHeader });
  }

}
